<nz-modal
  [(nzVisible)]="isModalOpen"
  [nzFooter]="null"
  [nzClosable]="false"
  (nzOnCancel)="handleModalState()"
  [nzWrapClassName]="'shortcuts-modal'"
>
  <ng-container *nzModalContent>
    <div class="header">
      <span class="title"
        >Keyboard Shortcuts (Type "?" or "/" To Open This Screen)</span
      >
      <va-icon (click)="handleModalState()" name="close"></va-icon>
    </div>

    <div class="content">
      <div *ngFor="let shortcut of shortcutMap" class="shortcut">
        <div class="symbol">{{ shortcut.symbol }}</div>
        <div class="explanation">{{ shortcut.text }}</div>
      </div>
    </div>
  </ng-container>
</nz-modal>
